export const manageQueryParams = (params = {}) => {
  const searchParams = new URLSearchParams(window.location.search);

  // Remove existing empty params
  Array.from(searchParams.entries()).forEach(([key, value]) => {
    const isEmpty =
      value === undefined ||
      value === null ||
      value === "" ||
      value === "false";

    if (isEmpty) {
      searchParams.delete(key);
    }
  });

  // Add / Update / Delete params
  Object.entries(params).forEach(([key, value]) => {
    const isEmpty =
      value === undefined ||
      value === null ||
      value === "" ||
      value === false ||
      (Array.isArray(value) && value.length === 0);

    if (isEmpty) {
      searchParams.delete(key);
    } else {
      // Array support
      if (Array.isArray(value)) {
        searchParams.set(key, value.join(","));
      } else {
        searchParams.set(key, value);
      }
    }
  });

  const queryString = searchParams.toString();

  const newUrl =
    window.location.pathname + (queryString ? `?${queryString}` : "");

  // Update URL without reload
  window.history.replaceState({}, "", newUrl);
};

export const getQueryParam = (key) => {
  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get(key) || "";
};
